import { render } from "./EditGoods.vue?vue&type=template&id=58f11220&scoped=true"
import script from "./EditGoods.vue?vue&type=script&lang=js"
export * from "./EditGoods.vue?vue&type=script&lang=js"

import "./EditGoods.vue?vue&type=style&index=0&id=58f11220&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58f11220"]])

export default __exports__